import { getTokenExpClaim } from "./get-token-exp-claim"

/**
 * Is token expired?
 *
 * @param token - JWT token to check
 * @param offsetSeconds - Optional offset in seconds to consider token expired earlier
 * @returns true if token is expired or invalid, false if valid
 */
export function isTokenExpired(token: string, offsetSeconds = 0): boolean {
  if (!token) return true

  try {
    const exp = getTokenExpClaim(token)
    if (typeof exp !== "number") return true
    return !(exp * 1000 > Date.now() + offsetSeconds * 1000)
  } catch {
    return true
  }
}
